import { RemoveVehicle } from '../../../src/components'

export default function Index() {
  return (
    <div className="cure-inner-container">
      <RemoveVehicle />
    </div>
  )
}
